<template>
  <div
    class="shop-ml-verification-page"
    data-test="shop-ml-verification__page"
    v-loading="true"
    :element-loading-text="$t('commons.loading')">
    <div data-test="shop-ml-verification__page"></div>
  </div>
</template>

<script>
export default {
  props: {
    magicLinkToken: { type: String, required: true },
  },
  async mounted() {
    await this.handleMagicLinkToken(this.magicLinkToken);
  },
  methods: {
    showErrorMessage() {
      this.$message.error({ message: this.$t('commons.defaultErrorMessage') });
    },
    showSuccessMessage() {
      this.$message.success({ message: this.$t('shopSignInPage.shopMLVerificationSuccess') });
    },
    async handleMagicLinkToken(token) {
      try {
        await this.$store.dispatch('shopAuth/handleMagicLinkToken', token);
        this.showSuccessMessage();
        this.$router.push({ name: 'Login' });
      } catch (e) {
        this.showErrorMessage();
        this.$router.push({ name: 'Home' });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.shop-ml-verification-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>
